export const questions = [
  "1. Why Choose PSP Over In-House Billing?",
  "2. What Does an RCM Analysis Include?",
  "3. Can We Help Recover Unpaid Accounts Receivable (AR)?",
  "4. How to Get Started: Onboarding & Implementation Steps?",
  "5. Why Use PSP Instead of In-House Billing?",
  "6. Does PSP Only Handle Billing? What Other Services Are Included in RCM?",
  "7. What Makes PSP Unique?",
  "8. How Quickly Can PSP Start Processing Claims?",
  "9. Does PSP Handle Multi-Specialty Practices?",
  "10. What Billing Software Does PSP Support?",
];

export const answers = [
  `<p>A Physician Service Provider (PSP) offers a smart way to manage medical billing and revenue cycles. Here's why PSP services stand out:</p>
<h5>98%+ Clean Claims Rate</h5>
<ul>
  <li>Ensures first-pass approvals with insurance companies, reducing denials and rework.</li>
  <li>Others often have a lower clean claims rate (85-90%), leading to more claim rejections.</li>
</ul>

<h5>Faster Reimbursements & Increased Revenue</h5>
<ul>
  <li>PSPs utilize AI-driven automation to submit, track, and manage claims efficiently.</li>
  <li>Practices experience a 20-30% increase in revenue due to better claim management and faster payments.</li>
</ul>

<h5>Competitive & Transparent Pricing</h5>
<ul>
  <li>PSP offers flexible, cost-effective pricing structures without hidden fees.</li>
  <li>Many competitors charge higher percentages (8-12%) on collections, cutting into practice revenue.</li>
</ul>`,

  `<p>PSP offers a complete revenue cycle management solution. This includes more billing support than competitors.</p>
<h5>Medical Billing & Coding</h5>
<ul>
  <li>Accurate CPT, ICD-10, and HCPCS coding to maximize reimbursements.</li>
  <li>Automated claim scrubbing reduces errors before submission.</li>
</ul>
<h5>Claims Processing & Denial Management</h5>
<ul>
  <li>Real-time claim tracking ensures rapid response to payer denials.</li>
  <li>Proactive denial prevention strategies minimize claim rejections.</li>
</ul>
<h5>Credentialing & Payer Enrollment</h5>
<ul>
  <li>Faster provider credentialing to ensure billing eligibility.</li>
  <li>Re-credentialing & contract renewals to prevent revenue disruptions.</li>
</ul>
<h5>Accounts Receivable (AR) & Revenue Recovery</h5>
<ul>
  <li>Specialized AR teams recover unpaid claims, reducing aging balances.</li>
  <li>PSP has helped recover millions in lost reimbursements for clients.</li>
</ul>
<h5>Compliance & Regulatory Oversight</h5>
<ul>
  <li>HIPAA-compliant data security & billing processes.</li>
  <li>Audit support & payer compliance checks to prevent revenue risks.</li>
</ul>`,
  `<p>Yes! PSP specializes in AR recovery, ensuring that practices receive payments quickly and efficiently.</p>
<h5>Our AR Recovery Process:</h5>
<ul>
  <li><strong>Identifying Unpaid Claims:</strong> Reviewing aging AR reports to determine the root cause of delays.</li>
  <li><strong>Aggressive Payer Follow-Ups: </strong> Communicating directly with insurance providers for status updates and appeals.</li>
  <li><strong>Denial Management & Appeals: </strong> Correcting and resubmitting denied claims for successful payment.</li>
  <li><strong>Patient Payment Solutions: </strong> Implementing automated reminders and flexible payment options.</li>
  <li><strong>Regular AR Reports: </strong> Keeping practices informed with detailed recovery tracking and financial reports.</li>
</ul>
<h5>Success Story:</h5>
<p>A multi-specialty clinic got back $500,000 in unpaid claims in just 90 days using PSP’s AR recovery strategy. Our team tracks every dollar. This cuts down on financial stress for medical practices.</p>
`,
  `<p>Starting with PSP’s billing & credentialing services is simple and efficient.</p>
<h5>Steps to Get Started:</h5>
<ul>
  <li><strong>Initial Consultation:</strong> Understanding the practice’s needs and current billing challenges.</li>
  <li><strong>Data & Documentation Setup: </strong> Collecting provider information, insurance contracts, and credentialing details.</li>
  <li><strong>Software Integration: </strong> Connecting with EHR & billing platforms for seamless claim processing.</li>
  <li><strong>Claims Testing & Process Optimization: </strong> Running test claims to ensure compliance and accuracy.</li>
  <li><strong>Go Live & Ongoing Support: </strong> Implementing the full billing cycle with real-time support and monitoring.</li>
</ul>
<p>PSP ensures a smooth transition with minimal disruption to the practice’s operations.</p>
`,
  `<p>Many businesses handle billing in-house, but partnering with PSP process has big benefits.</p>
<h5>Key Benefits of Partnering with PSP:</h5>
<ul>
  <li><strong>Years of Experience:</strong> Over a decade of expertise in medical billing & credentialing.</li>
  <li><strong>Scalability: </strong> We support both large and small practices. Our team has over 1,200 billing professionals.</li>
  <li><strong>Reduced Administrative Burden: </strong> Free up staff time to focus on patient care.</li>
  <li><strong>Higher Claim Approval Rates: </strong> Fewer denials and quicker reimbursements.</li>
  <li><strong>Cost Savings: </strong> Lower expenses compared to hiring a full-time billing team.</li>
</ul>
`,
  `<p>PSP provides a complete set of Revenue Cycle Management (RCM) services. This includes billing, coding, credentialing, and accounts receivable (AR) management.</p>
<h5>Complete RCM Services Include:</h5>
<ul>
  <li><strong>Medical Billing & Coding:</strong> Ensuring accurate CPT & ICD-10 coding for maximum reimbursement.</li>
  <li><strong>Credentialing & Provider Enrollment: </strong> Handling payer contracts and provider enrollments.</li>
  <li><strong>Denial Management: </strong> Reducing claim denials and securing maximum payouts.</li>
  <li><strong>Accounts Receivable (AR) Recovery: </strong> Following up on unpaid claims and patient balances.</li>
  <li><strong>Patient Billing & Collections: </strong> Managing statements, reminders, and payment processing.</li>
</ul>
<p>PSP offers complete RCM services. Practices get a partner who handles the whole revenue cycle from beginning to end.</p>
`,
  `<ul>
  <li><strong>Customized Solutions:</strong> Adapted billing services for specialty providers.</li>
  <li><strong>Real-Time Reporting:  </strong> Transparent access to billing & collection performance.</li>
  <li><strong>HIPAA & Compliance Assurance: </strong> Ensuring data security & regulatory compliance.</li>
  <li><strong>Dedicated Account Managers:  </strong> Personalized support for every practice.</li>
</ul>
`,
  `<p>Implementation takes 2-4 weeks, depending on practice size and system integration.</p>`,
  `<p>Yes! We work with primary care, specialists, hospitals, surgery centers, telehealth, and others.</p>`,
  `<p>We connect with all major EHRs and billing systems. This includes AthenaHealth, Kareo, eClinicalWorks, and others.</p>`,
];
